import { ModalComponent } from "cruzo/ui-components/modal";
import { appScope } from "site/api";

export type ZeptoRowSwapContext = {
  sourceRowIndex: number;
  rowCount: number;
  move: (targetRowIndex: number) => string | null;
};

let context: ZeptoRowSwapContext | null = null;

export function openZeptoRowSwapModal(next: ZeptoRowSwapContext): void {
  context = next;
  ModalComponent.attach("zeptoRowSwapModal", appScope.id);
}

export function getZeptoRowSwapContext(): ZeptoRowSwapContext | null {
  return context;
}

export function clearZeptoRowSwapContext(): void {
  context = null;
}
